import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router'
import { OrganizationsService } from '../services/organizations.service'

@Injectable()
export class DataResolver implements Resolve<any> {
  constructor(private OrganizationsService: OrganizationsService,private router:Router) {}

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<any[]> {
    try {
      const data : any= await this.OrganizationsService.pendingRejectedProfile(route.paramMap.get('id')).toPromise()
      if(data?.status == 2) this.router.navigate([`/layout/service-providers/organization-profile/${data?.id}`])
      return data
    } catch (error) {
      // Handle the error if data fetching fails
      throw error;
    }
  }
  // resolve(
  //   route: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot
  // ) {
  //   return this.OrganizationsService.pendingRejectedProfile(route.paramMap.get('id')).toPromise().then(
  //       (res:any)=> res?.result
  //   )
  // }
}
